export function enableDrag(el, drag) {
  el.onmousedown = function (e) {
    if (!e.target.classList.contains(drag)) return;
    e = e || window.event;
    var x_down = e.clientX;
    var y_down = e.clientY;
    var leftDown = this.offsetLeft;
    var topDown = this.offsetTop;
    document.onmousemove = function (e) {
      e = e || window.event;
      var x_move = e.clientX;
      var y_move = e.clientY;
      var x_now = x_move - x_down;
      var y_now = y_move - y_down;
      el.style.top = topDown + y_now + 'px';
      el.style.left = leftDown + x_now + 'px';
    };
    document.onmouseup = function () {
      this.onmousemove = this.onmouseup = null;
    };
    return false;
  };
}

export const assets = ({ icon, dir }) => {
  return require(`@/assets/image/virtual-phone${dir}/${icon}.png`);
};

/**
 * 移动端触摸方法定义
 */
export const touch = function (
  /** @type {Element} */ obj,
  /** @type {(type:String)=>void} */ emit
) {
  let opt = { top: 'top', bottom: 'bottom' };
  let init = { x: 5, y: 5, sx: 0, sy: 0, ex: 0, ey: 0, threshold: 38 };
  let record = { y: 0, ey: 0, d: 0, ed: 0 };
  let boundary = false;
  let stop = false;
  obj.addEventListener(
    'mousedown',
    function (e) {
      init.sy = e.y + obj.scrollTop;
      init.ex = init.sx;
      init.ey = init.sy;
      stop = true;
      const scrollBottom = obj.scrollHeight - obj.clientHeight;

      function resetY(v) {
        const top = (obj.scrollTop = init.sy - v);
        if (top <= 0) {
          init.sy = obj.scrollTop + v;
          boundary = opt.top;
        } else if (top >= scrollBottom) {
          init.sy = obj.scrollTop + v;
          boundary = opt.bottom;
        } else {
          boundary = false;
          stop = false;
        }
      }

      function prolong() {
        if (boundary) {
          boundary && emit(boundary);
          return;
        }
        if (Math.abs(record.ey - record.y) === 1) return;
        let len = (record.ey - record.y) * 100;
        let tick = 0;
        const t = init.threshold;
        function callback() {
          if (boundary || stop || (len >= -4 && len <= 5)) {
            boundary && emit(boundary);
            cancelAnimationFrame(callback);
            return;
          }
          tick = Math.ceil(len * 0.2);
          tick = tick > 0 ? (tick > t ? t : tick) : tick < -t ? -t : tick;
          len -= tick;
          resetY((record.ey += tick));
          requestAnimationFrame(callback);
        }
        callback();
      }

      function move(/** @type {Event} */ e) {
        e.preventDefault();
        resetY(e.y);
        record.y = record.ey;
        record.ey = e.y;
        record.d = Date.now();
      }

      function end(/** @type {Event} */ e) {
        e.preventDefault();
        document.body.removeEventListener('mousemove', move);
        document.body.removeEventListener('mouseup', end);
        record.ed = Date.now();
        if (record.ed - record.d < 80) prolong();
      }
      document.body.addEventListener('mouseup', end);
      document.body.addEventListener('mousemove', move);
    },
    false
  );

  /**
   * @param {Element} e
   */
  function listeningScroll(e) {
    const scrollBottom = obj.scrollHeight - obj.clientHeight;
    if (e.target.scrollTop + 10 - scrollBottom > 5) {
      emit(opt.bottom);
    }
  }
  obj.addEventListener('scroll', listeningScroll);
};

/**
 * 用于计算动态尺寸
 * @param {Number} curWidth
 * @returns 计算后大小
 */
export function makeCalculator(curWidth) {
  return (v, unit) => {
    unit = unit === 'none' ? '' : unit || 'px';
    return parseFloat((v / 720) * curWidth).toFixed(2) + unit;
  };
}
